import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService, httpOptions } from '@core/service/base.service';
import { catchError, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SrmpriceRepositoryService  extends BaseService{
  private url = "api/srmPurPrice";

  constructor(http: HttpClient) {
    super(http);
  }

  getUrl(){
    return this.url;
  }

  findBetweenDateAndStatus(date: any):Observable<any> {
    const url = "api/srmPurPrice/date";
    return this.http.post<any>(url,date, httpOptions).pipe(
      tap(_ => this.log("getSupplierSimple")),
      catchError(this.handleError<any>("getSupplierSimple"))
    );
  }
}
